"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const context_1 = require("../resources/context");
exports.promptDef = {
    name: 'do-next-step',
    description: 'Load plan and thread context, return an instruction to implement the next incomplete step.',
    arguments: [
        { name: 'planId', description: 'Plan id. Canonical form is the ULID (e.g. "pl_01J…"); the filename stem (e.g. "my-weave-plan-001") is also accepted and resolved.', required: true },
    ],
};
async function handle(root, args) {
    const planId = args['planId'];
    if (!planId)
        throw new Error('planId is required');
    // Primary (agent-supplied) id → suggest-on-miss.
    const { filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, planId);
    const plan = await (0, dist_1.loadDoc)(filePath);
    if (plan.type !== 'plan')
        throw new Error(`Document ${planId} is not a plan`);
    // Find first incomplete step
    const steps = plan.steps ?? [];
    const nextStep = steps.find(s => s.status !== 'done' && s.status !== 'cancelled');
    const messages = [];
    // Unified context pipeline: bundles global/weave/thread ctx + the plan's
    // parent chain + the plan itself (as target) + requires_load. Replaces the
    // old ad-hoc thread-context + separate plan-content push.
    try {
        const ctx = await (0, context_1.handleContextResource)(root, `loom://context/${planId}?mode=implementing`);
        messages.push({ role: 'user', content: { type: 'text', text: ctx.contents[0].text } });
    }
    catch { /* context is best-effort */ }
    const instruction = nextStep
        ? [
            `Implement step ${nextStep.order ?? '?'}${nextStep.id ? ` (id: ${nextStep.id})` : ''}: ${nextStep.description}`,
            '',
            `After completing this step, call loom_complete_step with planId="${planId}" and stepNumber=${nextStep.order}.`,
        ].join('\n')
        : `All steps are complete in plan ${planId}. You may close it using loom_close_plan.`;
    messages.push({ role: 'user', content: { type: 'text', text: instruction } });
    return {
        description: nextStep
            ? `Implement step ${nextStep.order} of ${planId}: ${nextStep.description}`
            : `All steps complete in ${planId}`,
        messages,
    };
}
